import React, { useEffect, useMemo } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { getAzureConfiguration, postAzureConfiguration, postStatus } from "@/services/setting.service";
import { AZURE_REGISTRATION_STEPS, BUTTONS, HEADINGS, LABELS, PLACEHOLDERS, TEXT } from "@/utils/constants/appConstants/commonConstants";
import { useFeaturePermission } from "@/utils/hooks/useFeaturePermission";
import { setDataInLocalStorage } from "@/utils/functions/helperFunctions";
import { FEATURE_PERMISSIONS } from "@/utils/constants/featurePermissions";

export const AzureRegistration = () => {
    const [msHost, setMsHost] = React.useState("");
    const [edit, setEdit] = React.useState(false);
    const [isUploaded, setIsUploaded] = React.useState(false);
    const [active, setActive] = React.useState(false);

    useEffect(() => {
        getAzureConfiguration()
            .then((res) => {
                setIsUploaded(!!res.data?.ms_host);
                setMsHost(res.data.ms_host || "");
                setActive(res.data.is_active);
            })
            .catch((e) => console.log(e));
    }, []);

    const onSubmit = async () => {
        if (msHost === "") return;
        postAzureConfiguration({ ms_host: msHost, is_active: true })
            .then(() => {
                setIsUploaded(true);
                setEdit(false);
                setActive(true);
                setDataInLocalStorage("aad", true);
            })
            .catch((e) => console.log(e));
    };

    const changeStatus = async () => {
        postStatus(!active, (res: any) => {
            setActive(res.is_active);
            localStorage.setItem("aad", res.status);
        });
    };

    const isUpdateIntegrationSettingPermitted = useFeaturePermission(FEATURE_PERMISSIONS.AdminPortalUpdateIntegrationSetting);

    const hostForm = (
        <div className="gs-azure-form">
            <div className="gs-azure-form__field">
                <label className="gs-azure-form__label" id="sharepoint-intergration-host-label" htmlFor="sharepoint-intergration-host-input">
                    {LABELS.SHAREPOINT_HOST_INPUT_LABEL}
                </label>
                <Input
                    id="sharepoint-intergration-host-input"
                    autoFocus
                    value={msHost}
                    onChange={(e) => setMsHost(e.target.value)}
                    placeholder={PLACEHOLDERS.SHAREPOINT_HOST}
                    className="gs-azure-form__input"
                />
            </div>
            <Button type="button" onClick={onSubmit} className="gs-azure-form__submit" id="sharepoint-intergration-submit-btn">
                {BUTTONS.SUBMIT}
            </Button>
        </div>
    );

    return (
        <div className="gs-azure-page">
            <div className="gs-azure-card">
                {isUpdateIntegrationSettingPermitted && (
                    <div className="gs-azure-card__section gs-azure-card__section--bordered">
                        {isUploaded ? (
                            <>
                                <h6 className="gs-azure-section__title" id="sharepoint-intergration-manage-host">
                                    {HEADINGS.MANAGE_YOUR_SHAREPOINT_HOST}
                                </h6>
                                <div className="gs-azure-manage-actions">
                                    <Button
                                        type="button"
                                        variant={active ? "destructive" : "default"}
                                        className="gs-azure-manage-btn"
                                        onClick={changeStatus}
                                        id="sharepoint-intergration-status-btn"
                                    >
                                        {active ? "Deactivate" : "Activate"}
                                    </Button>
                                    <Button
                                        type="button"
                                        variant={edit ? "outline" : "default"}
                                        className="gs-azure-manage-btn"
                                        onClick={() => setEdit(!edit)}
                                        id={`sharepoint-intergration-${edit ? "cancel" : "edit-configuration"}-btn`}
                                    >
                                        {edit ? "Cancel" : "Edit Configuration"}
                                    </Button>
                                </div>
                                {edit && (
                                    <div className="gs-azure-edit-panel" id="sharepoint-intergration-edit-input">
                                        {hostForm}
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                                <h6 className="gs-azure-section__title" id="register-for-sharepoint-label">
                                    {TEXT.REGISTER_FOR_SHAREPOINT_WITH_GREENSIGN}
                                </h6>
                                <div id="register-for-sharepoint-input">{hostForm}</div>
                            </>
                        )}
                    </div>
                )}

                <div className="gs-azure-card__section">
                    <h6 className="gs-azure-section__title" id="adding-sharepoint-admin">
                        {TEXT.INSTRUCTIONS_FOR_ADDING_SHAREPOINT_ADDIN}
                    </h6>
                    <ol className="gs-azure-steps">
                        {AZURE_REGISTRATION_STEPS.map((step, index) => (
                            <li key={index} className="gs-azure-steps__item" id={`sharepoint-adding-instruction-${index}`}>
                                {step}
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        </div>
    );
};
